import { useEffect } from 'react';
import Input from '../../../components/Form/Input/Input';
import useStyles from '../styles';
import { lastNChars, numbersIn } from '../../../utils/common/common';
import EventUtils from '../../../utils/events';
import { useOnMessage } from '../../../utils/hooks';
import WalletAlpha from '../../../services/walletAlpha/walletAlpha';

function OTPInput({
  onChangeValue,
  onPaste,
  inputNumber,
  value,
  innerRef,
  nextOTPInputRef,
  previousOTPInputRef,
}: OTPInputProps) {
  const classes = useStyles();

  useOnMessage(WalletAlpha.messages.NUVEM_CLEAR_INPUTS, async () => {
    if (innerRef && inputNumber === 0) {
      innerRef.current?.focus();
    }
  });

  useEffect(() => {
    if (innerRef && inputNumber === 0) {
      innerRef.current.focus();
    }
  }, []);

  const handleChange = (event: React.KeyboardEvent<HTMLInputElement>) => {
    const { value: currentValue } = event.target as HTMLInputElement;

    if (!currentValue) {
      onChangeValue(currentValue);
    } else {
      const newValue = lastNChars(1, numbersIn(currentValue));

      if (newValue) {
        onChangeValue(newValue);
        if (nextOTPInputRef) nextOTPInputRef.current.focus();
      }
    }
  };

  const onKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (EventUtils.isDeleting(event) && previousOTPInputRef && !value) {
      previousOTPInputRef.current.focus();
    }
  };

  return (
    <Input
      innerRef={innerRef}
      data-testid={`input${inputNumber}`}
      key={inputNumber}
      className={classes.otpInput}
      maxLength={2}
      onChange={handleChange}
      onPaste={onPaste}
      value={value}
      onKeyDown={onKeyDown}
    />
  );
}

export default OTPInput;
